<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-card>
    <el-row>
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/Refund/myApproveList' }">退款系统</el-breadcrumb-item>
          <el-breadcrumb-item>抄送我的</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <!-- 搜索框区域 -->
    <!-- <el-row>
      <el-col :span="7">
        <el-input 
        placeholder="请输入退款账户名称" class="input-with-select" v-model="keywords">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-col>
    </el-row> -->
    <!-- 表格区域 -->
    <el-table :data="tableData" border v-loading="loading" stripe style="width: 100%">
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="Title" label="标题" width="280"></el-table-column>
      <el-table-column prop="StepName" label="当前步骤" width="180"></el-table-column>
      <el-table-column prop="ReceiveName" label="处理人" width="200"></el-table-column>
      <el-table-column prop="SenderTime" label="发起时间"></el-table-column>
      <el-table-column label="操作" width="280">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-view" size="mini" @click="Dialog_box(scope.row)">查看</el-button>
          <el-dialog title="审批详情" :visible.sync="DialogVisible" width="70%" center>
            <div class="drawer_box">
              <el-steps :active="level" align-center>
                <el-step v-for="(item, index) in TimeLines" :key="index" :title="item.Name" :status="item.Result">
                  <template slot="description">
                    <div>{{item.CompletedTime}}</div>
                    <div>{{item.Handler}}</div>
                    <div>{{item.ResultMessage}}</div>
                  </template>
                </el-step>
              </el-steps>
              <el-row class="box_info" :gutter="20">
                <el-col :span="10" style="text-algin:right;">
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.RefundTypes ? true : false">
                    退款类型
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.OrderNo ? true : false">
                    订单号
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.MainName ? true : false">
                    申请部门
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.TrueName ? true : false">
                    申请人
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.ComanyName ? true : false">
                    公司名称
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.LinkName ? true : false">
                    客户联系人
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.LinkPhone ? true : false">
                    客户联系电话
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.Product !=='' ? true : false">
                    退款产品
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.RefundStyle !=='' ? true : false">
                    退款方式
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsOpenTicket !=='' ? true : false">
                    是否开发票
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsAgreement !=='' ? true : false">
                    是否签合同
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsOpen !=='' ? true : false">
                    是否开户
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsBack !=='' ? true : false">
                    是否撤单完成
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsHaveAgreement !=='' ? true : false">
                    是否有合同
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.BecauseOfA ? true : false">
                    是否有合同原因
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsHaveReceipt !=='' ? true : false">
                    是否有收据
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.BecauseOfR ? true : false">
                    是否有收据原因
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsHaveTicket !=='' ? true : false">
                    是否有发票
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.BecauseOfT ? true : false">
                    是否有发票原因
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.RefundMoney !=='' ? true : false">
                    退款金额
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.RefundBecause ? true : false">
                    退款原因
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.RefundBecauseOf ? true : false">
                    退款原因详情
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.AccountName ? true : false">
                    用户名
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsLoseTicket !=='' ? true : false">
                    发票是否遗失
                  </div>
                  <div class="grid-content bg-purple text_right" v-if="rowInfo.IsDeposit !=='' ? true : false">
                    预存款是否消费完毕
                  </div>
                  <div  class="grid-content bg-purple text_right" v-if="rowInfo.ConsumeMoney !== '' ? true : false">
                    已消费金额
                  </div>
                  <!-- 上传资料部分 -->
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.RefundConfirmation ? true : false">
                    退款确认书
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Qualifications ? true : false">
                    主体资质复印件
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.LegalCard ? true : false">
                    法人身份证复印件
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Entrust ? true : false">
                    委托授权书
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.EntrustCard ? true : false">
                    被委托人身份证复印件
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Ticket ? true : false">
                    发票
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Agreement ? true : false">
                    合同
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Receipt ? true : false">
                    收据
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.TicketLose ? true : false">
                    发票遗失说明
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Transfers ? true : false">
                    转账确认书
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.Customer ? true : false">
                    客户资质
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.AccountPic ? true : false" >
                    两个账户后台截图
                  </div>
                  <div class="grid-content bg-purple text_right item_height" v-if="Material.License ? true : false">
                    两个账户营业执照复印件
                  </div>
                </el-col>

                <!-- 绑定值区域 -->
                <el-col :span="8">
                  <div class="grid-content bg-purple-light" v-if="rowInfo.RefundTypes ? true : false">
                    {{ rowInfo.RefundTypes }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.OrderNo ? true : false">
                    {{ rowInfo.OrderNo }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.MainName ? true : false">
                    {{ rowInfo.MainName }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.TrueName ? true : false">
                    {{ rowInfo.TrueName }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.ComanyName ? true : false">
                    {{ rowInfo.ComanyName }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.LinkName ? true : false">
                    {{ rowInfo.LinkName }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.LinkPhone ? true : false">
                    {{ rowInfo.LinkPhone }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.Product !=='' ? true : false">
                    {{ rowInfo.Product }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.RefundStyle !=='' ? true : false">
                    {{ rowInfo.RefundStyle }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsOpenTicket !=='' ? true : false">
                    {{ rowInfo.IsOpenTicket == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsAgreement !=='' ? true : false">
                    {{ rowInfo.IsAgreement == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsOpen !=='' ? true : false">
                    {{ rowInfo.IsOpen == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsBack !=='' ? true : false">
                    {{ rowInfo.IsBack == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsHaveAgreement !=='' ? true : false">
                    {{ rowInfo.IsHaveAgreement == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.BecauseOfA ? true : false">
                    {{ rowInfo.BecauseOfA }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsHaveReceipt !=='' ? true : false">
                    {{ rowInfo.IsHaveReceipt == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.BecauseOfR ? true : false" >
                    {{ rowInfo.BecauseOfR }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsHaveTicket !=='' ? true : false">
                    {{ rowInfo.IsHaveTicket == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.BecauseOfT ? true : false">
                    {{ rowInfo.BecauseOfT }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.RefundMoney !=='' ? true : false" >
                    {{ rowInfo.RefundMoney }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.RefundBecause ? true : false">
                    {{ rowInfo.RefundBecause }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.RefundBecauseOf ? true : false">
                    {{ rowInfo.RefundBecauseOf }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.AccountName ? true : false">
                    {{ rowInfo.AccountName }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsLoseTicket !=='' ? true : false">
                    {{ rowInfo.IsLoseTicket == 0 ? "否" : "是" }}
                  </div>
                  <div class="grid-content bg-purple-light" v-if="rowInfo.IsDeposit !=='' ? true : false">
                    {{ rowInfo.IsDeposit == 0 ? "否" : "是" }}
                  </div>                
                  <div class="grid-content bg-purple-light" v-if="rowInfo.ConsumeMoney !=='' ? true : false">
                    {{ rowInfo.ConsumeMoney }}
                  </div>
                  <!-- 上传资料区域 -->
                  <div class="grid-content bg-purple-light item_height" v-if="Material.RefundConfirmation ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.RefundConfirmation)">查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Qualifications ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Qualifications)">查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.LegalCard ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.LegalCard)">查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Entrust ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Entrust)">查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.EntrustCard ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.EntrustCard)">查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Ticket ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Ticket)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Agreement ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Agreement)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Receipt ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Receipt)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.TicketLose ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.TicketLose)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Transfers ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Transfers)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.Customer ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.Customer)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.AccountPic ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.AccountPic)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                  <div class="grid-content bg-purple-light item_height" v-if="Material.License ? true : false">
                    <el-button size="mini" type="primary" @click="download_doc(Material.License)" >查看<i class="el-icon-download "></i></el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination
      style="text-align:left;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10,20,50,100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    </el-card>
  </div>
</template>
<script>
import {
  GetWaitTasks,
  GetInformationId,
  GetStepTimeLine,
  GetInformation,
  Excuteflow,
  GetFlowSendNextSteps,
  GetCCUser
} from "../../until/ZeusApiSDK/Logic/RefundLogic";
import { cryptoDecode } from "../../until/encrypt.js"

export default {
  //inject: ["reload"],
  data() {
    return {
      userInfo: {},
      keywords: "",
      DialogVisible: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      currentPage: 1,
      searchInstance: [],
      TimeLines: [],
      level: 0,
      rowInfo: {},
      Material: {},
      loading : true
    };
  },
  methods: {
    GetCCUser:async function(){
      var res = await GetCCUser(this.userInfo.userid,this.pageIndex,this.pageSize);
      this.total = res.TotalCount;
      this.tableData = res.DataList;
      this.loading = false;
    },
    //监听每页展示多少条数据改变事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetCCUser();
    },
    //监听当前页码改变事件
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetCCUser();
    },
    // 下载模板
    download_doc(file_path) {
      window.open(file_path);
    },
    async Dialog_box(row) {
      this.DialogVisible = true;
      await GetStepTimeLine(this.userInfo.userid, row.InstanceID).then(res => {
        res.TimeLines.forEach(e => {
          if (e.Result == '0') {
            e.Result = "wait";
          } else if (e.Result == 2) {
            e.Result = "finish";
          } else if (e.Result == 3) {
            e.Result = "error";
          } else if (e.Result == 4) {
            e.Result = "finish";
          } else if (e.Result == 5) {
            e.Result = "error";
          }
        });
        this.TimeLines = res.TimeLines;
        this.level = res.NowStep;
      });
      await GetInformation(row.InstanceID).then(res => {
        if (res.result.RefundTypes == 0) {
          res.result.RefundTypes = "未消费退款";
        } else if (res.result.RefundTypes == 1) {
          res.result.RefundTypes = "已经消费退款";
        } else if (res.result.RefundTypes == 2) {
          res.result.RefundTypes = "已经消费转账户";
        } else if (res.result.RefundTypes == 3) {
          res.result.RefundTypes = "保证金";
        }
        this.rowInfo = res.result;
        this.Material = res.result.Material;
      });
    }
  },
  created() {
    // 3503bdf1-e379-4ac1-80d4-b60a5056433c 胡双林 id
    // 06d85c33-df0f-4953-a3e3-690f15d2a7d9 张雨 id
    // 60bd66a6-b834-48d7-90c6-2b2120cd642b 申阳 id
    var userinfo = JSON.parse(cryptoDecode(window.sessionStorage.getItem('userinfo')));
    this.userInfo.TrueName = userinfo.TrueName
    this.userInfo.userid = userinfo.UserId;
    this.GetCCUser();
    
  }
};
</script>
<style lang="less" scoped>
.el-table {
  margin-top: 15px;
}
.el-pagination {
  margin-top: 15px;
}
.el-drawer {
  padding: 0 15px !important;
}
.drawer_box {
  width: 100%;
}
.el-dropdown {
  transform: translateY(10px);
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.text_right {
  text-align: right;
}
.text_left {
  text-align: left;
}
.item_height {
  height: 40px;
  line-height: 40px;
}
</style>
